import { useState, useEffect } from 'react';;

import useWindowSize from 'hooks/use-windowSize';
import UseModal from 'hooks/use-modal';
import UseToast from 'hooks/use-toast';

import { useQuery } from 'react-query';
import { exportResume } from 'services/cv';
import { downloadFile } from 'utils/fileConvert';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import AboutMe from './Resume/AboutMe';
import WorkExperiences from './Resume/WorkExperiences';
import Educations from './Resume/Educations';
import Skills from './Resume/Skills';
import UserFullName from 'components/common/userfullname/UserFullName';
import Modal from '@core/components/Modal/Modal';
import PremiumFeatureModal from '@core/components/premiumfeaturemodal/PremiumFeatureModal';
import ResumeCompleteness from '@core/components/resumecompleteness/ResumeCompleteness';
import LinkButton from '@core/components/linkbutton/LinkButton';
import ResumeMoreOptions from 'components/pages/myresume/ResumeMoreOptions';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';
import { PROFILE_DETAIL_ERROR } from '@core/constants/Errors';

import ImportResume from './ImportResume';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import ActionButton from '@core/components/actionbutton/ActionButton';
import AnalyzeMyResume from './AnalyzeMyResume';
import ImportNewResumeButton from './ImportNewResumeButton';
import AnalyzeData from './AnalyzeData';

import ExpandMoreIcon from 'assets/icons/arrow-down.svg';

import { Edit } from 'iconsax-react';

import classes from './ResumeFilled.module.scss';

const ResumeFilled = ({ data, refetchMyResume, hasSubscription }) => {
	const [activeTab, setActiveTab] = useState(data?.skill_insights ? 2 : 1);
	const handleTabChange = (event, newValue) => {
		setActiveTab(newValue);
	};
	const { toast, ToastContainer } = UseToast();
	const { show: showGoPremium, showModal: showGoPremiumModal, destroyModal: destroyGoPremiumModal } = UseModal();
	const { mobileDevice, tabletDevice, desktopDevice } = useWindowSize();
	const {
		show: showFullname,
		destroyModal: destroyFullnameModal,
		showModal: showFullnameModal
	} = UseModal();
	const { data: cv_pdf, isFetching, error, refetch } = useQuery(['user-resume-export'], exportResume,
		{
			onSuccess: (cv_pdf) => {
				downloadFile(cv_pdf);
			},
			onError: (error) => {
				if (error?.response?.status === +PROFILE_DETAIL_ERROR) {
					showFullnameModal();
				}
				else
					toast(
						'There is a problem on the CV export. Please try later.',
						'alert'
					);
			},
			refetchOnMount: 'always',
			cacheTime: 0,
			enabled: false,
		});

	useEffect(() => {
		if (data?.skill_insights) {
			setActiveTab(2);
		}
		else {
			setActiveTab(1);
		}
	}, [data?.skill_insights]);

	return (
		<>
			<ToastContainer />
			<div className='container p-lg-0'>
				<div className={`row gx-xl-5 ${classes["resume-filled"]}`}>
					<div className="col-12  d-flex flex-column ">
						<div className={`${classes['my-resume-title']} row gap-3 gap-lg-0`}>
							<div className='col-lg-8 col-12'>
								<div className={`${classes['contact-info']} ${data?.skill_insights ? classes['has-insights'] : ''} d-flex align-items-center justify-content-between flex-sm-row flex-column gap-3`}>
									<div className='d-flex flex-column align-items-start justify-content-center gap-2'>
										<h3>{data.user.first_name} {data.user.last_name}</h3>
										{data.contact_information.email && <span>{data.contact_information.email}</span>}
										{data.contact_information.phone_number && <span>{data.contact_information.phone_number}</span>}
									</div>
								</div>
								<div className={`${classes['more-options']} ${data?.skill_insights ? classes['has-insights'] : ''}`}>
									<div className='d-flex flex-column flex-md-row align-items-center gap-3 justify-content-between px-3'>
										<LinkButton kind='primary-light' to={'/cover-letter'}>
											Create Cover Letter
										</LinkButton>
										<div className={classes['actions-section']}>
											{hasSubscription ? (
												<LinkButton kind='simple' to={'/profile/my-resume/edit'}>
													{/* <Edit /> */}
													Edit Resume
												</LinkButton>
											) : (
												<ActionButton kind='secondary' onClick={() => showGoPremiumModal()}>
													{/* <Edit /> */}
													Edit Resume
												</ActionButton>
											)}
											<ImportNewResumeButton smart_cv_import_access_status={data?.smart_cv_import_access_status} showGoPremiumModal={showGoPremiumModal} toast={toast} refetch={refetchMyResume} />
										</div>
									</div>

									<ResumeMoreOptions
										data={data}
										downloadResumeHandler={refetch}
										isDownloading={isFetching}
										toast={toast}
										refetch={refetchMyResume}
										hasSubscription={hasSubscription}
										showGoPremiumModal={showGoPremiumModal}
									/>
								</div>
							</div>
							<div className='col-lg-4 col-12'>
								<div className={classes['resume-insights-wrapper']}>
									{/* <ResumeCompleteness percent={data.completeness} /> */}
									<AnalyzeMyResume refetchMyResume={refetchMyResume} toast={toast} skill_insights={data?.skill_insights} cv_skill_insights_access_status={data?.cv_skill_insights_access_status} showGoPremiumModal={showGoPremiumModal} />
									{/* <div className={classes['profile-setting']}>
										Change your profile visibility from  <LinkButton kind='simple' to={'/setting'}>Setting</LinkButton>
									</div> */}
								</div>
							</div>
						</div>
						<TabContext value={activeTab}>
							<TabList
								onChange={handleTabChange}
								variant="scrollable"
								className='mb-3'
							>
								<Tab
									value={1}
									label='Resume'
								/>
								<Tab
									value={2}
									label='Analyze'
								/>
							</TabList>
							<TabPanel sx={{ padding: '5px 0' }} value={1}>
								<div className='d-flex flex-column gap-4'>
									<AboutMe data={data.about_me} isNewStep={false} />
									{!mobileDevice && (
										<>
											<WorkExperiences data={data.work_experience} refetchMyResume={refetchMyResume} isNewStep={false} />
											<Educations data={data.education} refetchMyResume={refetchMyResume} isNewStep={false} />
											<Skills data={data.skills} refetchMyResume={refetchMyResume} isNewStep={false} />
											{/* <Certificates data={data.certificates} metaData={data.certificate_metadata} /> */}
										</>
									)}
								</div>
								{mobileDevice && (
									<div className={`${classes['resume-filled-accardion']}`}>
										{data?.work_experience?.work_experiences?.length > 0 && (
											<Accordion>
												<AccordionSummary
													expandIcon={<ExpandMoreIcon />}
													aria-controls="panel1a-content"
													id="panel1a-header">
													<Typography>Work Experience</Typography>
												</AccordionSummary>
												<AccordionDetails>
													<WorkExperiences data={data.work_experience} refetchMyResume={refetchMyResume} />
												</AccordionDetails>
											</Accordion>
										)}
										{data.education.education.length > 0 && (
											<Accordion>
												<AccordionSummary
													expandIcon={<ExpandMoreIcon />}
													aria-controls="panel1a-content"
													id="panel1a-header">
													<Typography>Education</Typography>
												</AccordionSummary>
												<AccordionDetails>
													<Educations data={data.education} refetchMyResume={refetchMyResume} />
												</AccordionDetails>
											</Accordion>
										)}
										{(data.skills.software_skills || data.skills.technical_skills) && (
											<Accordion>
												<AccordionSummary
													expandIcon={<ExpandMoreIcon />}
													aria-controls="panel1a-content"
													id="panel1a-header">
													<Typography>Skills</Typography>
												</AccordionSummary>
												<AccordionDetails>
													<Skills data={data.skills} refetchMyResume={refetchMyResume} />
												</AccordionDetails>
											</Accordion>
										)}
									</div>
								)}
							</TabPanel>
							<TabPanel sx={{ padding: '5px 0' }} value={2}>
								<AnalyzeData data={data?.skill_insights} />
							</TabPanel>
						</TabContext>
					</div>
				</div>
			</div>
			<Modal type={MOBILE_SLIDE_UP} show={showFullname} closeHandler={destroyFullnameModal}>
				<div className={`${classes['user-fullname-wrapper-modal']} d-flex flex-column gap-2`}>
					<UserFullName
						title=""
						description="We need your name to continue. Enter your name below. Please note that your name is not editable later"
						callback={destroyFullnameModal}
					/>
				</div>
			</Modal>
			<Modal
				type={MOBILE_SLIDE_UP}
				show={showGoPremium}
				closeHandler={destroyGoPremiumModal}
				header={false}
				isGoPermium={true}
			>
				<PremiumFeatureModal closeHandler={destroyGoPremiumModal} featureName={'resume'} />
			</Modal>

		</>
	);
};

export default ResumeFilled;
